import * as yup from 'yup';

export default yup.object().shape({
  name: yup.string().required().min(2).trim().nullable(),
  email: yup.string().trim().email().nullable(),
  phone: yup.string().trim().nullable(),
});
